import Component from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Alternatives/AlternativesViews/Domain/queries';

@Component
export default class AlternativesViewsQueries extends VueCqrs
{
	runAlternativesViewQueryV1(workspaceId: number, alternativesListId: number, viewDefId: string)
	{
		const query = q.buildAlternativesViewQueryV1(workspaceId, alternativesListId, viewDefId);
		this.$query(query);
	}

	runListsPageQueryV1(workspaceId: number, projectId: number, viewDefId: string)
	{
		const query = q.buildListsPageQueryV1(workspaceId, projectId, viewDefId);
		this.$query(query);
	}

	runListDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativesViewId: string)
	{
		const query = q.buildListDependenciesQueryV1(workspaceId, projectId, alternativesListId, alternativesViewId);
		this.$query(query);
	}
}
